import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-product-variant-selector-modal.html';
import {events} from '@nuskin/ns-util';

import '@nuskin/ns-style-elements';

/**
 * The ns-product-variant-selector-modal should be used for
 *
 * <h1>Product Variant Selector</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-product-variant-selector-modal class="demoElement"></ns-product-variant-selector-modal>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsProductVariantSelectorModal extends PolymerElement {
    constructor() {
        super();
    }

    ready() {
        super.ready();
        this.setListeners();
        this.setScrollingArea();
    }

    static get is() {
        return "ns-product-variant-selector-modal";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            /**
             * Toggles functionality if logged in
             */
            isLoggedIn: Boolean,
            /**
             * Toggles the visibility of the modal
             */
            opened: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
             * Sku used for sending back selected product
             */
            originalSku: String,
            /**
             * Translations object that include the values:
             */
            translations: {
                type: Object,
                value: {
                    "label": "Select an Option"
                }
            },
            /**
             * variant array with product objects
             */
            variants: Array,
            /**
             * Which variant in the array is selected
             */
            variantIndex: Number
        };
    }

    /**
     * Closes the modal
     */
    closeProductVariantSelectorModal() {
        this.$.productVariantSelectorModal.close();
    }

    /**
     * Opens the modal
     */
    openProductVariantSelectorModal() {
        this.$.productVariantSelectorModal.open();
    }

    /**
     * Sets event listener to open and close the modal
     */
    setListeners() {
        events.subscribe(events.shop.HIDE_PRODUCT_VARIANT_SELECTOR_MODAL, () => {
            this.closeProductVariantSelectorModal();
        });
        events.subscribe(events.shop.SHOW_PRODUCT_VARIANT_SELECTOR_MODAL, variantData => {
            this.setProductProperties(variantData);
            this.openProductVariantSelectorModal();
        });
    }

    /**
     * Sets the variant data as it was pulled from the variant dropdown selector component
     */
    setProductProperties(variantData) {
        this.originalSku = variantData.initSku ? variantData.initSku : variantData.sku;
        this.variantIndex = variantData.variantIndex;
        this.set('variants', variantData.variants);
        this.set('translations.title', variantData.variantDropdownPlaceholder);
    }

    /**
     * Defines the scroll height for the body of the modal
     */
    setScrollingArea() {
        this.updateStyles({
            "--selector-modal__scroll-height":  this.shadowRoot.querySelector(".product-variant-selector-modal__body").offsetHeight - this.shadowRoot.querySelector(".product-variant-selector-modal__title").offsetHeight  + "px"
        });
    }

    /**
     * Returns the variant chosen back to the dropdown and product card
     */
    variantSelected() {
        events.publish(events.shop.HIDE_PRODUCT_VARIANT_SELECTOR_MODAL, {
            "newVariant": this.variants[this.variantIndex],
            "originalSku": this.originalSku,
            "index": this.variantIndex
        });
    }

}
customElements.define(NsProductVariantSelectorModal.is, NsProductVariantSelectorModal);
